/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-anchor,
.qds-breadcrumb-item {
  color: var(--qds-theme-control-text-standard);
}

.qds-breadcrumb-item {
  font: var(--qds-control-standard-text);
  display: inline-flex;
  height: var(--qds-control-standard-height);
  align-items: center;
  gap: var(--qds-control-standard-gap-siblings-related);
  flex-shrink: 0;
  list-style: none;
}

.qds-anchor {
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: var(--qds-focus-border-width) solid var(--qds-theme-focus-border);
    outline-offset: var(--qds-focus-border-offset);
    border-radius: var(--qds-focus-border-radius);
  }
}
